/* eslint-disable max-len */
import {defineMessages} from 'react-intl';

export default defineMessages({
	personalDataProcessingTitle: {
		id: 'myAccount.personalData.processing.title',
		defaultMessage: 'Consent forms for personal data processing',
	},
	termsAndPolicy: {
		id: 'myAccount.personalData.processing.termsAndPolicy',
		defaultMessage:
			'By creating an account, I accept <terms>terms and conditions</terms> and confirm that I have read <privacy>privacy policy</privacy>.*',
	},
	marketing: {
		id: 'myAccount.personalData.processing.marketing',
		defaultMessage:
			'I consent to the processing of my personal data for marketing purposes (newsletters, news and promotions).',
	},
	profiling: {
		id: 'myAccount.personalData.processing.profiling',
		defaultMessage: 'I consent for profiling.',
	},
	required: {
		id: 'forms.fields.acceptsMarketing.error.required',
		defaultMessage: 'This field is required.',
	},
});
